import React from 'react';

export default function H2_ST({data}) {

  return (
      <h2 className='center'>{data?.Titre}</h2>
  );
}
